module.exports = __webpack_public_path__ + "67c89f7cade4753066fa58814e61cee2.png";